<div class="home-container">
	<div class="home-wrapper">
		<div #templateOutlet class="home-content"></div>
	</div>
</div>